/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { QaEquipmentCatalogDtoIotDeviceStateOfUse } from './QaEquipmentCatalogDtoIotDeviceStateOfUse';
import {
    QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSON,
    QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSONTyped,
    QaEquipmentCatalogDtoIotDeviceStateOfUseToJSON,
} from './QaEquipmentCatalogDtoIotDeviceStateOfUse';
import type { QaEquipmentCatalogDtoRegistrationState } from './QaEquipmentCatalogDtoRegistrationState';
import {
    QaEquipmentCatalogDtoRegistrationStateFromJSON,
    QaEquipmentCatalogDtoRegistrationStateFromJSONTyped,
    QaEquipmentCatalogDtoRegistrationStateToJSON,
} from './QaEquipmentCatalogDtoRegistrationState';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface QaEquipmentCatalogDto
 */
export interface QaEquipmentCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof QaEquipmentCatalogDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof QaEquipmentCatalogDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof QaEquipmentCatalogDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof QaEquipmentCatalogDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {QaEquipmentCatalogDtoIotDeviceStateOfUse}
     * @memberof QaEquipmentCatalogDto
     */
    iotDeviceStateOfUse?: QaEquipmentCatalogDtoIotDeviceStateOfUse | null;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof QaEquipmentCatalogDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {boolean}
     * @memberof QaEquipmentCatalogDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {QaEquipmentCatalogDtoRegistrationState}
     * @memberof QaEquipmentCatalogDto
     */
    registrationState?: QaEquipmentCatalogDtoRegistrationState | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentCatalogDto
     */
    $type?: QaEquipmentCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const QaEquipmentCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoQaEquipmentCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.QaEquipmentCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type QaEquipmentCatalogDtoTypeEnum = typeof QaEquipmentCatalogDtoTypeEnum[keyof typeof QaEquipmentCatalogDtoTypeEnum];


/**
 * Check if a given object implements the QaEquipmentCatalogDto interface.
 */
export function instanceOfQaEquipmentCatalogDto(value?: unknown): value is QaEquipmentCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(QaEquipmentCatalogDtoTypeEnum)[0];
}

export function QaEquipmentCatalogDtoFromJSON(json: any): QaEquipmentCatalogDto {
    return QaEquipmentCatalogDtoFromJSONTyped(json, false);
}

export function QaEquipmentCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentCatalogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'state': !exists(json, 'state') ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'iotDeviceStateOfUse': !exists(json, 'iotDeviceStateOfUse') ? undefined : QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSON(json['iotDeviceStateOfUse']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'registrationState': !exists(json, 'registrationState') ? undefined : QaEquipmentCatalogDtoRegistrationStateFromJSON(json['registrationState']),
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function QaEquipmentCatalogDtoToJSON(value?: QaEquipmentCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'iuid': value.iuid,
        'serialNumber': value.serialNumber,
        'category': RtSystemCategoryToJSON(value.category),
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'typeNumber': value.typeNumber,
        'state': QaEquipmentStateOfUseToJSON(value.state),
        'iotDeviceStateOfUse': QaEquipmentCatalogDtoIotDeviceStateOfUseToJSON(value.iotDeviceStateOfUse),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'isAvailable': value.isAvailable,
        'registrationState': QaEquipmentCatalogDtoRegistrationStateToJSON(value.registrationState),
        'masterDeviceId': value.masterDeviceId,
        'imageId': value.imageId,
        '$type': value.$type,
    });
}

